import React, { useState, useEffect } from 'react';
import { Star, User } from 'lucide-react';
import axios from 'axios';
import { API } from '../../constants';

const FALLBACK_REVIEWS = [
  { name: 'Martin K.', car: 'BMW E90', rating: 100, stars: 5, text: 'Svetlomety vyzerajú ako nové! Profesionálny prístup a výsledok nad očakávania. Určite odporúčam.' },
  { name: 'Peter S.', car: 'Audi A4 B8', rating: 100, stars: 5, text: 'Hviezdny strop je neskutočný, presne ako som si predstavoval. Precízna práca a férová cena.' },
  { name: 'Tomáš H.', car: 'VW Passat B7', rating: 100, stars: 5, text: 'Plexisklá vymenené rýchlo a kvalitne. Svetlá svietia ako z fabriky. Ďakujem!' },
  { name: 'Lucia M.', car: 'Škoda Octavia III', rating: 90, stars: 4.5, text: 'Ambient osvetlenie je krásne, veľmi spokojná. Len termín sa trochu posunul, ale výsledok stojí za to.' },
  { name: 'Jakub R.', car: 'Mercedes C-Class W204', rating: 100, stars: 5, text: 'Repas svetlometov za super cenu. Žiadne zbytočné reči, len kvalitná práca. Vrátim sa.' },
  { name: 'Miroslav D.', car: 'Ford Focus MK3', rating: 100, stars: 5, text: 'DRL oprava hotová za pár hodín. Konečne svietia obe strany rovnako. Odporúčam všetkým.' },
];

export const ReviewsSection = () => {
  const [reviews, setReviews] = useState(FALLBACK_REVIEWS);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const res = await axios.get(`${API}/reviews`);
        if (res.data && res.data.length > 0) {
          setReviews(res.data);
        }
      } catch (e) { /* keep fallback */ }
    };
    fetchReviews();
  }, []);

  const StarRating = ({ stars }) => (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map(i => (
        <Star
          key={i}
          size={14}
          className={i <= Math.floor(stars) ? 'text-yellow-400 fill-yellow-400' : i - 0.5 <= stars ? 'text-yellow-400 fill-yellow-400/50' : 'text-zinc-600'}
        />
      ))}
    </div>
  );

  return (
    <section id="reviews" data-testid="reviews-section" className="py-24 md:py-32 bg-white/[0.02]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#00BFFF] mb-4">
            Hodnotenia
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl tracking-tight font-medium">
            Čo hovoria zákazníci
          </h2>
          <p className="text-zinc-400 mt-4 max-w-2xl mx-auto">
            Spokojnosť našich zákazníkov je pre nás najlepšia vizitka
          </p>
        </div>

        {/* Stats bar */}
        <div className="flex flex-wrap justify-center gap-8 md:gap-16 mb-14">
          <div className="text-center">
            <p className="text-4xl font-bold text-[#00BFFF]">99%</p>
            <p className="text-sm text-zinc-500 mt-1">Spokojnosť</p>
          </div>
          <div className="text-center">
            <p className="text-4xl font-bold text-[#00BFFF]">4.9</p>
            <p className="text-sm text-zinc-500 mt-1">Priemerné hodnotenie</p>
          </div>
          <div className="text-center">
            <p className="text-4xl font-bold text-[#00BFFF]">200+</p>
            <p className="text-sm text-zinc-500 mt-1">Realizácií</p>
          </div>
        </div>

        {/* Reviews grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((review, idx) => (
            <div
              key={idx}
              data-testid={`review-${idx}`}
              className="group p-6 bg-white/[0.03] border border-white/10 hover:border-[#00BFFF]/30 transition-all duration-300"
            >
              <div className="flex items-center justify-between mb-4">
                <StarRating stars={review.stars} />
                <span className={`text-xs font-bold px-2 py-1 ${
                  review.rating === 100 ? 'bg-green-500/10 text-green-400' : 'bg-yellow-500/10 text-yellow-400'
                }`}>
                  {review.rating}%
                </span>
              </div>
              <p className="text-zinc-300 text-sm leading-relaxed mb-5">
                "{review.text}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-white/5">
                <div className="w-9 h-9 rounded-full bg-[#00BFFF]/10 flex items-center justify-center">
                  <User size={16} className="text-[#00BFFF]" />
                </div>
                <div>
                  <p className="text-sm font-medium text-white">{review.name}</p>
                  <p className="text-xs text-zinc-500">{review.car}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
